export default function (context, val) {
    context.commit('set_form', {ContragentID: val});


    let contragent = context.getters.options_contragents[0];
    if (!contragent) return;
    context.commit('set_form', {
        ContragentName: contragent.label,
        PartnerLegalEntityId: contragent.legalId,
    });

    context.dispatch('agreement_comment');
    context.state.form.AgreementCodes.forEach(code => {
        context.dispatch('agreement_getCourse',code);
    });
}